import { TextField, styled } from "@mui/material";
import { ediphiPalette } from "../../styles/colors";

/** Placeholder text. Deliberately lighter than `textMuted` so it reads as absent, not secondary. */
const PLACEHOLDER_COLOR = "#9b9b9b";

export const InputField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  "& .MuiInputBase-input": {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
  },
  "& .MuiInputBase-input::placeholder": {
    color: PLACEHOLDER_COLOR,
    opacity: 1,
  },
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: ediphiPalette.mainBackground,
    "& .MuiOutlinedInput-notchedOutline": { borderColor: ediphiPalette.borderInput },
  },
}));
